"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimpleDesktopDropdownMenuLink = void 0;
const react_1 = __importDefault(require("react"));
const NavLink_atom_1 = require("../atoms/link/NavLink.atom");
function SimpleDesktopDropdownMenuLink({ link = {}, locale = 'en-US', disableHrefTemplate }) {
    if (!link)
        return null;
    return (react_1.default.createElement(NavLink_atom_1.NavLink, { link: link, className: "simple-menu-link", role: "menuitem", locale: locale, disableHrefTemplate: disableHrefTemplate }, link.title));
}
exports.SimpleDesktopDropdownMenuLink = SimpleDesktopDropdownMenuLink;
//# sourceMappingURL=SimpleDesktopDropdownMenuLink.js.map